import React, { ReactElement, useState } from 'react'
import {
    Grid,
} from '@maggioli-design-system/react'

interface Props {
    selectOrderBy: Function,
    defaultValue?: string,
}

export default function OrderBy({ selectOrderBy, defaultValue = "Pertinenza" }: Props): ReactElement {

    const options: string[] = ['Pertinenza', 'Data'];

    const [orderBy, setOrderBy] = useState<string>(defaultValue);

    const setSelectOrderBy = (value: string) => {
        setOrderBy(value);
        selectOrderBy(value);
    }

    // Stessa struttura degli altri filtri: la label è associata al campo tramite htmlFor
    return (
        <Grid gutter="xsmall">
            <label htmlFor="select-ordinamento" className="-mb-2 text-base uppercase font-bold">Ordina per</label>
            <div className='select__item'>
                <select className="select__field text-secondary text-secondary--detail" id="select-ordinamento"
                        onChange={(e) => setSelectOrderBy(e.target.value)} value={orderBy}>
                    { options.map((o, i) => <option key={i} className="select__option " value={o}>{o}</option> )}
                </select>
                <i aria-hidden="true" className="icon icon--size-normal select__icon mgg-icons-navigation-show"></i>
            </div>
        </Grid>
    )
}
